import { Palette } from '@mui/material/styles/createPalette'
import { GraphColorDefinitionType } from 'src/Libs/graph-cards/types'

export const buildGraphColorDefinitons = (palette: Palette, itemCount: number): [Map<number, GraphColorDefinitionType>, GraphColorDefinitionType] => {
  const defaultFallbacks = {
    default: { backgroundColor: palette.primary.light, color: palette.common.white },
    light: { backgroundColor: palette.primary.dark, color: palette.common.white },
  } as GraphColorDefinitionType

  const colors = new Map<number, GraphColorDefinitionType>([
    [
      0,
      {
        default: { backgroundColor: palette.primary.light, color: palette.primary.dark },
        light: { backgroundColor: palette.primary.dark, color: palette.common.white },
      },
    ],
    [
      1,
      {
        default: { backgroundColor: palette.purple.light, color: palette.purple.main },
        light: { backgroundColor: palette.purple.main, color: palette.common.white },
      },
    ],
    [
      2,
      {
        default: { backgroundColor: palette.warning.light, color: palette.blue.main },
        light: { backgroundColor: palette.blue.main, color: palette.common.white },
      },
    ],

    [
      3,
      {
        default: { backgroundColor: palette.warning.light, color: palette.warning.main },
        light: { backgroundColor: palette.warning.main, color: palette.common.white },
      },
    ],
  ])

  return [colors, defaultFallbacks]
}
